import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Typography } from '@mui/material';

export default function AchatSelector({ productId, value, onChange }) {
  const [achats, setAchats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productId) return;
    setLoading(true);
    setError(null);
    fetch(`/api/achats?produit=${productId}`)
      .then(res => res.json())
      .then(data => {
        setAchats(data);
        setLoading(false);
      })
      .catch(() => {
        setError('Erreur lors du chargement des achats');
        setLoading(false);
      });
  }, [productId]);

  // Filtrage supplémentaire côté frontend
  const achatsFiltres = achats.filter(achat => achat["Produit"] === productId);

  // Fonction utilitaire pour obtenir la DateAchat
  const getAchatDate = (achat) => {
    const raw = achat.dateAchat || achat["Date_achat"] || achat["DateAchat"];
    if (!raw) return null;
    const d = new Date(raw);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleDateString('fr-FR');
  };

  // Fonction utilitaire pour obtenir le prix d'achat
  const getAchatPrix = (achat) => {
    const prix = achat.prixAchat ?? achat["Prix d'achat"] ?? achat["Prix_achat"];
    if (prix === undefined || prix === null) return '-';
    return Number(prix).toFixed(2) + '€';
  };

  if (loading) return <CircularProgress size={20} />;
  if (error) return <Typography color="error" variant="caption">{error}</Typography>;

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Achat</InputLabel>
      <Select
        value={value || ''}
        label="Achat"
        onChange={e => onChange(e.target.value)}
        displayEmpty
      >
        {achatsFiltres.map(achat => {
          const date = getAchatDate(achat);
          const prix = getAchatPrix(achat);
          return (
            <MenuItem key={achat.id} value={achat.id}>
              {date ? `${date} – ${prix}` : JSON.stringify(achat)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
} 